import { ButtonBase, Stack, Typography, alpha } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
  label?: string;
  value: string | number;
  selectedValue: string | number;
  disabled?: boolean;

  variant?: 'column' | 'row';

  handleSelectItem?(value: string | number): () => void;
}

const PaiRadioItem: React.FC<Props> = ({ label, value, variant = 'column', selectedValue, disabled, handleSelectItem }) => {
  const { classes, cx } = useStyles();

  const active = selectedValue === value;

  return (
    <Stack
      className={cx(classes.radioItem, disabled ? 'disabled' : null, _.isNil(handleSelectItem) ? 'disable-pointers' : null)}
      direction={'row'}
      gap={1.5}
      alignItems={'center'}
    >
      <ButtonBase className={classes.radioClickArea} onClick={!_.isNil(handleSelectItem) ? handleSelectItem(value) : undefined} disableRipple={true}>
        <div className={cx(classes.radio, active ? 'active' : null, disabled ? 'disabled' : null)} />
      </ButtonBase>
      {!_.isNil(label) ? (
        <ButtonBase onClick={!_.isNil(handleSelectItem) ? handleSelectItem(value) : undefined} disableRipple={true}>
          <Typography className={cx(classes.radioText, active && variant === 'row' ? 'active' : null, disabled ? 'disabled' : null)}>
            {label}
          </Typography>
        </ButtonBase>
      ) : null}
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  radioItem: {
    '&.disabled': {
      color: theme.palette.greys.medium,
      pointerEvents: 'none',
    },
    '&.disable-pointers': {
      pointerEvents: 'none',
    },
  },
  radioClickArea: {
    padding: '4px',
    margin: '-4px',
    borderRadius: '50%',
    transition: '225ms',
    '&:hover': {
      background: alpha(theme.palette.primary.main, 0.2),
    },
  },
  radio: {
    width: '14px',
    height: '14px',
    borderRadius: '50%',
    border: `1px solid ${theme.palette.greys.medium}`,
    transition: '225ms',
    '&.active': {
      border: `1px solid ${theme.palette.primary.main}`,
      background: theme.palette.primary.main,
    },
    '&.disabled': {
      '&.active': {
        border: `1px solid ${theme.palette.greys.lighter}`,
        background: theme.palette.greys.lighter,
      },
    },
  },
  radioText: {
    fontSize: theme.typography.pxToRem(13),
    textAlign: 'start',
    '&.active': {
      color: theme.palette.primary.main,
    },
    '&.disabled': {
      textDecorationColor: theme.palette.greys.lighter,
    },
  },
}));

export default PaiRadioItem;
